
export const RECRUITER_ROLES = {
    DATA_ANALYST: 'DA', // Data Analyst
};
